<template>
  <div class="dot-pagination">
    <div
      v-for="page in pages"
      :key="page"
      class="dp-item"
      :class="{
        'dp-item--active': activePage === page,
      }"
      tabindex="0"
      @click.prevent="$emit('select', page)"
      @keydown.enter="$emit('select', page)"
      @keydown.space.prevent="$emit('select', page)"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  pages: number;
  activePage?: number;
}>();
defineEmits(['select']);
</script>

<style lang="scss" scoped>
.dot-pagination {
  position: relative;
  display: flex;

  .dp-item {
    display: block;
    width: 6px;
    height: 6px;
    margin-right: math.div($pad, 2);
    background-color: palette(sand, base);
    border-radius: 100%;
    cursor: pointer;
    transition:
      0.1s ease-in transform,
      0.1s ease-in background-color;

    &:last-child {
      margin-right: 0;
    }

    &:focus,
    &:hover {
      outline: 0;
      transform: scale(1.5);
      background-color: palette(grey, light);
    }

    &.dp-item--active {
      transform: scale(1.5);
      background-color: $color-brand-fnmz-green;
      cursor: default;
    }
  }
}
</style>
